<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>

      <loading
            :active.sync="loadingTratamientos"
            :can-cancel="false"
            :is-full-page="true"
        ></loading>
        <b-row class="text-center mt-4">
          <b-col cols="1" md="3">
          </b-col>

          <b-col cols="9" md="6" >
            <div>
              <b-row class="contenedorTablaSinColor" style="background:white">
                <b-col cols="10" lg="11" class="pr-0">
                  <b-input-group class="pl-3" >
                    <b-form-input
                        class="input-filter"
                        maxLength="15"
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        responsive
                        placeholder="Búsqueda de clinica"
                        @keydown.enter.native="buscarClinicas()"
                    >

                    </b-form-input>
                    <b-input-group-append >
                      <b-dropdown
                          class="input-filter"
                          @hide="search.etapaSearch = ''"
                          variant="white"
                          responsive
                      >
                        <template #button-content>
                    <span :class="filtrosSeleccionados.length > 0 ? 'filtro' : 'filtro-normal'">
                      {{ filtrosSeleccionados.length > 0 ? '(' + filtrosSeleccionados.length + ') Filtros' : 'Filtros' }}
                    </span>
                        </template>


                        <div class="contenedor-drop">
                          <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                            <b-form-checkbox
                                v-for="option in estatus"
                                v-model="filtrosSeleccionados"
                                :key="option.idEstatusEtapa"
                                :value="option.idEstatusEtapa"
                                :aria-describedby="ariaDescribedby"
                                name="flavour-3a"
                            >
                              {{ option.descripcion }}
                            </b-form-checkbox>
                          </b-form-group>

                        </div>
                      </b-dropdown>
                    </b-input-group-append>

                  </b-input-group>
                </b-col>
                <b-col cols="2" lg="1" class="pl-0">
                  <b-button
                      class="mt-1"
                      size="sm"
                      variant="info"
                      :disabled="loading"
                      @click="buscarClinicas"
                      responsive
                  >
                <span v-if="!loading"
                >
                  <em class="buscar_svg primary sm"></em>
                </span>
                    <span v-else><b-spinner small></b-spinner></span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>

          <b-col cols="1" class="text-left">
            <b-button
                v-if="$localStorageService.can('BO_28_clini_Alta')"
                variant="primary"
                v-b-tooltip.hover
                title="Alta de Clínica"
                class="paddingbotones botonesAzulFuerte"
                @click="altaClinica"
                responsive
            ><em class="clinica_svg icon-boton"></em>
            </b-button>
          </b-col>

          <div class="col-12 mt-3">
            <br>
            <b-row class="contenedorTablaSinColor">
              <b-col sm="12" md="12" lg="12">
                <b-table
                    small
                    :fields="fields"
                    :items="items"
                    :per-page="registrosPorPagina"
                    :current-page="currentPage"
                    responsive
                    thead-tr-class="columnasTablaSinColor"
                    caption-top>

                  <template v-slot:cell(Acciones)="row" style="width: 200px">

                    <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones paddingbotones"
                              style="border-radius:5px"
                              v-if="$localStorageService.can('BO_28_clini_sillon')"
                              v-b-tooltip.hover
                              title="Editar Sillones"
                              @click="llamarModalSillones(row.item)">
                      <em class="editar_svg sm"></em>
                    </b-button>
                    <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones paddingbotones"
                              style="border-radius:5px"
                              v-if="$localStorageService.can('BO_28_clini_zona')"
                              v-b-tooltip.hover
                              title="Editar Zona de precios"
                              @click="llamarModalZonaPrecios(row.item)">
                      <em class="editar_svg sm"></em>
                    </b-button>
                    <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                              v-if="$localStorageService.can('BO_28_clini_Act_Edit_Elim')"
                              v-b-tooltip.hover
                              title="Editar"
                              @click="llamarModal(row.item)">
                      <em class="editar_svg sm"></em>
                    </b-button>

                    <b-button size="sm" variant="primary" class="mr-1 mt-1 marginbotones paddingbotones"
                              v-if="$localStorageService.can('BO_28_clini_Act_Edit_Trat')"
                              v-b-tooltip.hover
                              title="Editar Tratamientos"
                              @click="editarTratamientos(row.item)">
                      <em class="tratamientos_svg icon-boton"></em>
                    </b-button>
                    <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                              v-if="$localStorageService.can('BO_28_clini_Act_Edit_Elim')"
                              v-b-tooltip.hover
                              title="Dar de baja"
                              @click="desactivar(row.item.idClinica, row.item.strNombre)">
                      <em class="eliminar_svg icon-boton"></em>
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" class="mr-1 mt-1 marginbotones botonConfigEstilo"
                              v-if="$localStorageService.can('BO_28_clini_Act_Edit_Config')"
                              v-b-tooltip.hover
                              title="Configuración Clinica"
                              @click="editarConfiguracion(row.item)">
                      <b-icon icon="gear-fill" aria-label="Help"></b-icon>
                    </b-button>


                  </template>
                </b-table>
                <div align="center" v-if="loading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b-col v-else>
                  <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
                <b-pagination
                    align="center"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="registrosPorPagina"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>

        </b-row>

        <b-modal
                v-if="$localStorageService.can('BO_28_clini_Act_Edit_Elim')"
                v-model="mostrarModal"
                size="xl"
                class="redondeo"
                centered
                :no-close-on-backdrop="true">

          <template #modal-header="{ ok, close }">
            <div class="seccionTitle mLeft h5">
              <em class="icono cita_svg" style="filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%); height: 30px"></em>
              <div class="headerTxt mLeft">{{titulo}}</div>
            </div>
          </template>

            <altaClinicaV2 ref="modalModificar" v-if="mostrarModal"

                         :mostrarGuardar="mostrarGuardar"
                         :clinicaOriginal="clinicaSeleccionada"
                         @actualizar="buscarClinicasRegistro"/>
            <template #modal-footer="{ ok, cancel }">
              <div class="w-100 float-none text-center">
                <b-button
                        v-if="$localStorageService.can('BO_15_colob_Acti_crear')"
                        class="mt-3 botonesAzulFuerte"
                        variant="primary"
                        style="margin:10px"
                        @click="$refs.modalModificar.$refs.submitGuardar.click()">Guardar</b-button>

                <b-button
                        class="mt-3 botonesGrisFuerte"
                        style="margin:10px"
                        @click="() => {mostrarModal = false}">Cancelar
                </b-button>
              </div>
            </template>
        </b-modal>
        <b-modal
            v-if="$localStorageService.can('BO_28_clini_sillon')"
            v-model="mostrarModalSillones"
            size="xl"
            :title="'Modificar sillones de la clinica' + clinicaSeleccionada.strNombre"
            scrollable
            :no-close-on-backdrop="true">
            <modSillonesClinica ref="modalModificarSillones" v-if="mostrarModalSillones"
                                :clinicaOriginal="clinicaSeleccionada" @actualizar="buscarClinicasRegistro"/>
          <template #modal-footer="{ ok, cancel }">
            <b-button
                v-if="$localStorageService.can('BO_28_clini_sillon')"
                class="mt-3 botonesfooter"
                variant="outline-primary"
                style="width:10%;margin:10px"

                block
                @click="$refs.modalModificarSillones.$refs.submitGuardar.click()">Guardar</b-button>

            <b-button
                class="mt-3 botonesfooter"
                variant="outline-danger"
                style="width:10%;margin:10px"
                block
                @click="() => {mostrarModalSillones = false}">Cancelar
            </b-button>
          </template>
        </b-modal>
        <b-modal
            v-if="$localStorageService.can('BO_28_clini_zona')"
            v-model="mostrarModalZonaPrecios"
            size="xl"
            :title="'Modificar zona de precios de la clinica ' + clinicaSeleccionada.strNombre"
            scrollable
            :no-close-on-backdrop="true">
            <modZonaPagoClinica ref="modalModificarZonaPrecios" v-if="mostrarModalZonaPrecios"
                                   :clinicaOriginal="clinicaSeleccionada" @actualizar="buscarClinicasRegistro"/>
          <template #modal-footer="{ ok, cancel }">
            <b-button
                v-if="$localStorageService.can('BO_28_clini_zona')"
                class="mt-3 botonesfooter "
                variant="outline-primary"
                style="width:10%;margin:10px"
                block
                @click="$refs.modalModificarZonaPrecios.$refs.submitGuardar.click()">Guardar</b-button>

            <b-button
                class="mt-3 botonesfooter"
                variant="outline-danger"
                style="width:10%;margin:10px"
                block
                @click="() => {mostrarModalZonaPrecios = false}">Cancelar
            </b-button>
          </template>
        </b-modal>
        <b-modal
            v-if="$localStorageService.can('BO_28_clini_Act_Edit_Trat')"
            v-model="mostrarModalEditarTratamientos"
            size="xl"
            :title="'Seleccionar los tratamientos de la clinica ' + clinicaSeleccionada.strNombre"
            :no-close-on-backdrop="true">

          <b-row>
            <b-col cols="6">
              <b-form-input
                  v-model="filterTratamientos"
                  type="search"
                  class="mb-4"
                  placeholder="Buscar tratamiento">
              </b-form-input>
            </b-col>
            <b-col cols="6">
              <b-button-group>
                <b-button size="sm" @click="seleccionarTodosTratamientos" variant="outline-primary">Seleccionar todos</b-button>
                <b-button
                    size="sm"
                    @click="quitarTodosTratamientos"
                    variant="outline-danger"
                    style="margin-left: 10px"
                >Quitar todos</b-button>
              </b-button-group>
            </b-col>

          </b-row>
          <b-table
              responsive
              sticky-header
              striped
              style="height: 200px"
              thead-tr-class="columnas"
              :items="tratamientosClinicas"
              :fields="titulosTratamientos"
              :filter="filterTratamientos"
          >
            <template v-slot:cell(Seleccionar)="row">
              <b-form-checkbox
                  v-model="row.item.activo">
              </b-form-checkbox>
            </template>
          </b-table>

          <template #modal-footer="{ ok, cancel }">
            <b-button
                v-if="$localStorageService.can('BO_28_clini_Act_Edit_Trat')"
                class="mt-3 botonesfooter"
                variant="outline-primary"
                style="width:10%;margin:10px"
                block
                @click="guardarEditarTratamientos">Guardar</b-button>

            <b-button
                class="mt-3 botonesfooter"
                variant="outline-danger"
                style="width:10%;margin:10px"
                block
                @click="() => {mostrarModalEditarTratamientos = false}">Cancelar
            </b-button>
          </template>
        </b-modal>
        <b-modal
            v-model="mostrarModalConfiguracionClinica"
            size="xl"
            :title="'Modificar configuracion de la clínica ' + clinicaSeleccionada.strNombre"
            :no-close-on-backdrop="true"
            no-close-on-esc
            hide-header-close>
            <configuracion @buscarClinicas="buscarClinicas" :clinicaOriginal="clinicaSeleccionada" ref="configClinica"
                           :meses="meses"
                           :bancos="bancos"/>
          <template #modal-footer="{ ok, cancel }">
            <b-button
                class="mt-3 botonesfooter"
                variant="outline-danger"
                style="margin:10px"
                @click="validacionCerrarModal">Salir
            </b-button>
          </template>
        </b-modal>
    </div>
</template>

<script>

    import modSillonesClinica from './modSillonesClinica';
    import modZonaPagoClinica from './modZonaPagoClinica';
    import configuracion from "@/views/perfilPacientes/configuracion.vue";
    import altaClinicaV2 from "@/views/perfilPacientes/altaClinicaV2.vue";


    export default {
        name: "clinicasActivas",
        components: {
          modSillonesClinica,
          modZonaPagoClinica,
          configuracion,
          altaClinicaV2,
        },
        props: {
            filtro: String
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                loading: false,
                loadingTratamientos: false,
                fields: [
                    {key: "idClinica", label: "Id clínica", sortable: true},
                    {key: "nombreEstado", label: "Estado", sortable: true},
                    {key: "zonaNombre", label: "Región", sortable: true},
                    {key: "strNombre", label: "Clínica", sortable: true},
                    {key: "strNombreCorto", label: "Nombre corto", sortable: true},
                    {key: "tipoClinica", label: "Tipo", sortable: true},
                    {key: "numeroSillones", label: "Sillones", sortable: true},
                    {key: "blnRegistraIngresos", label: "Registra ingresos", sortable: true, formatter: this.$formatoSINOFuncion},
                    {key: "escanerFits", label: "Escaner fits", sortable: true, formatter: this.$formatoSINOFuncion},
                    "Acciones",
                ],
                titulosTratamientos: [
                  {key: "nombreTratamiento", label: "Tratamiento", sortable: true},
                  "Seleccionar",
                ],
                currentPage: 1,
                items: [],
                registrosPorPagina:10,

                mostrarModal: false,
                titulo: "",
                mostrarModalSillones: false,
                mostrarModalZonaPrecios: false,
                mostrarModalEditarTratamientos: false,
                tratamientosClinicas:[],
                clinicaSeleccionada: {},
                filterTratamientos: null,

                mostrarModalConfiguracionClinica: false,
              search: {
                clinicaSearch: "",
                etapaSearch: "",
                clasificacionSearch: "",
              },
              estatus: [
                { idEstatusEtapa: 1, descripcion: "ECE" },
                { idEstatusEtapa: 2, descripcion: "Descentralizado" },
                { idEstatusEtapa: 3, descripcion: "Comision Bloque" },
              ],
              mostrarGuardar: false,
              filtrosSeleccionados: [],
              filtrosClinica: {
                filtroEce: false,
                filtroDescentralizado: false,
                filtroBloque: false
              },
              meses: [],
              bancos: [],

            };
        },
        mounted() {
          this.buscarClinicas();
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      },

      methods: {
        obtenerBancos() {
          this.$http.get(this.$api + "catalogos/listaBancos")
              .then((respuesta) => {
                if (respuesta.data.data) {
                  this.bancos = respuesta.data.data;
                }
              });
        },
        obtenerMesesPlazoFijo(){
         let filtroMsi = {
            id: null,
                numeroPlazo: null,
                registroActivo: null
          };
          this.meses = [];
          this.$http.post(this.$api + "plazoFijo/obtener", filtroMsi).then(respuesta => {
                if (respuesta.data.data) {
                  this.meses = respuesta.data.data
                }
              }
          ).finally(() => {
            this.loader = false;
          })
        },
          altaClinica() {
            this.mostrarModal = true;
            this.titulo = "Alta de nueva clínica";
            this.clinicaSeleccionada = {};
            this.mostrarGuardar = true;
          },
            buscarClinicasRegistro(filtro) {
                this.filtro = filtro;
                this.mostrarModal = false;
                this.mostrarModalSillones = false;
                this.mostrarModalZonaPrecios = false;
                this.limpiarFiltros();
                this.buscarClinicas();
            },
            limpiarFiltros() {
              this.filtrosClinica = {
                filtroEce: false,
                filtroDescentralizado: false,
                filtroBloque: false
              }
            },
            buscarClinicas() {
                this.limpiarFiltros();
                this.filtrosSeleccionados.forEach(filtro => {
                  if (filtro === 1) {
                    this.filtrosClinica.filtroEce = true
                  } else if(filtro === 2) {
                    this.filtrosClinica.filtroDescentralizado = true
                  } else if(filtro === 3) {
                    this.filtrosClinica.filtroBloque = true
                  }
                })
                this.currentPage = 1;
                this.loading = true;
                this.items = [];
                const parametros = {detalle: this.filtro, filtros: this.filtrosClinica}
                this.$http
                    .post(this.$api + "catalogos/listaClinicasActivas", parametros)
                    .then((response) => {
                        this.items = response.data.data;
                        // this.items.dias.forE(p=> moment(p.end_time).format('hh:mm'));

                    }).finally(() => {
                    this.obtenerMesesPlazoFijo();
                    this.obtenerBancos();
                    this.loading = false;
                });
            },
            llamarModal(item) {
                this.clinicaSeleccionada = item;
                this.mostrarModal = true;
                this.titulo = "Modificar clínica";
                this.mostrarGuardar = false;
            },
            llamarModalSillones(item) {
              this.clinicaSeleccionada = item;
              this.mostrarModalSillones = true;
            },
            llamarModalZonaPrecios(item) {
              this.clinicaSeleccionada = item;
              this.mostrarModalZonaPrecios = true;
            },
            desactivar(idClinica, nombreClinica) {

                this.$swal.fire({
                    title: "¿Desea dar de baja la clínica?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    showLoaderOnConfirm: true,

                    preConfirm: () => {
                        this.loading = true;
                        const params = {
                          idClinica: idClinica,
                          registroActivo: false
                        }
                        this.$http
                            .put(this.$api + "catalogos/activarDesactivarClinica", params)
                            .then((response) => {
                                this.filtro = nombreClinica;
                                this.buscarClinicas();
                                this.$swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Se desactivó la clínica "+response.data.data,
                                    showConfirmButton: false,
                                    timer: 3500,
                                });
                            }).finally(() => {
                            this.loading = false;
                        });
                    },
                });

            },
          activarECEClinica(idClinica, estatus) {
                  this.loading = true;
                  const parametros = {idClinica: idClinica}
                  this.$http
                      .post(this.$api + "catalogos/activarEceClinica", parametros)
                      .then(() => {
                        if(estatus==true) {
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se activo ECE de la clínica con ID " + idClinica,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }else{
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se desactivo ECE de la clínica con ID " + idClinica,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }
                      }).finally(() => {
                    this.loading = false;
                  });
          },
          activarHdxClinica(idClinica, strNombre, estatus) {
                  this.loading = true;
                  const parametros = {idClinica: idClinica}
                  this.$http
                      .post(this.$api + "catalogos/activarHdxClinica", parametros)
                      .then(() => {
                        if(estatus!=true) {
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se activó descentralización para la clínica " + strNombre,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }else{
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se desactivó descentralización para la clínica " + strNombre,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }
                      }).finally(() => {
                    this.loading = false;
                  });
          },

          activarComisionBloque(idClinica, strNombre, estatus) {
            const parametros = {idClinica: idClinica}
                  this.loading = true;
                  this.$http
                      .post(this.$api + "catalogos/cambiarEstatusComisionBloque", parametros)
                      .then(() => {
                        if(estatus==true) {
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se activó la comisión de bloque para la clínica " + strNombre,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }else{
                          this.$swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se desactivó la comisión de bloque para la clínica " + strNombre,
                            showConfirmButton: false,
                            timer: 3500,
                          });
                        }
                      }).finally(() => {
                    this.loading = false;
                  });
          },
            editarTratamientos(item) {
              this.clinicaSeleccionada = item;
              this.tratamientosClinicas = [];
              this.filterTratamientos = null;
              this.loadingTratamientos = true;
              const parametros = {idClinica: Number(this.clinicaSeleccionada.idClinica)}
              this.$http
                  .post(this.$api + "tratamientos/obtenerTratamientosClinicasCompleto", parametros)
                  .then((response) => {
                    this.tratamientosClinicas = response.data.data;
                    this.mostrarModalEditarTratamientos = true;
                  }).catch((error)=>{
                console.error(error);
                this.$swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Ocurrio un error al obtener información de la clínica",
                  showConfirmButton: false,
                  timer: 3500,
                });
              }).finally(() => {
                this.loadingTratamientos = false;
              });

            },
          editarConfiguracion(item) {
            this.clinicaSeleccionada = item;
            this.mostrarModalConfiguracionClinica = true;
          },
            seleccionarTodosTratamientos() {
              this.tratamientosClinicas.forEach(it=>it.activo = true);
            },
            quitarTodosTratamientos() {
              this.tratamientosClinicas.forEach(it=>it.activo = false);
            },
            guardarEditarTratamientos() {

              this.$swal.fire({
                title: "¿Desea guardar los tratamientos de la clínica?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: () => {
                  this.loadingTratamientos = true;

                  const datosGuardar = {
                    "idClinica": this.clinicaSeleccionada.idClinica,
                    "tratamientos": this.tratamientosClinicas
                  };

                  this.$http
                      .put(this.$api + "tratamientos/guardarTratamientosClinicasCompleto", datosGuardar)
                      .then(() => {
                        this.$swal.fire({
                          position: "center",
                          icon: "success",
                          title: "Se guardo con éxito",
                          showConfirmButton: true
                        });
                        this.mostrarModalEditarTratamientos = false;
                      })
                      .catch(()=>{
                        this.$swal({
                            icon: "error",
                            title:
                              "Ocurrio un error al guardar",
                            confirmButtonText: "OK"
                          });
                      })
                      .finally(() => {
                    this.loadingTratamientos = false;
                  });
                },
              });

            },
            validacionCerrarModal() {
              if (!this.$refs.configClinica.tieneExpClinicos()) {
                this.$swal.fire({
                  position: "center",
                  icon: "warning",
                  title: "Debes seleccionar al menos un módulo del ECE.",
                  showConfirmButton: true
                });
              } else {
                this.mostrarModalConfiguracionClinica = false
              }
            }
        },
        computed: {
            rows() {
                return this.items.length;
            },

        },
        watch: {
            filtro() {
                this.$emit("actualizarFiltro", this.filtro);
            }
        }

    };
</script>

<style scoped>
.filtro {
  color: var(--color-icono);
  font-weight: bolder;
}


.filtro-normal {
  color:black;
  font-weight: normal;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}

.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
.icon-boton-agenda {
  filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%);
  height: 20px;
  display: block;
}
.redondeo{
  border-radius: 10px !important;
}

.botonesGrisFuerte {
  border-radius: 10rem;
  color: #fff;
  margin-left: 5%;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.paddingbotones {
  padding: 5px;
}

.marginbotones{
  border-radius:20px;
}

.icon-redondo{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.botonConfigEstilo {
  padding-bottom: 4px;
  padding-top: 5px;
  padding-left: 6px;
  padding-right: 7px;
}
</style>
